import * as members from '../privates/privateMembers';

function getRMI (instance) {
    return members._RMI.get(instance);
}

function getCompId (instance) {
    return members._compId.get(instance);
}

function getControllerId (instance) {
    return members._controllerId.get(instance);
}

function getContextId (instance) {
    return members._contextId.get(instance);
}

function setProp (instance, value) {
    getRMI(instance).setProps(getCompId(instance), value);
}

function getProp (instance, valueName) {
    return getRMI(instance).getProps(getCompId(instance))[valueName];
}

function setData (instance, value) {
    getRMI(instance).setData(getCompId(instance), value);
}

function setDataWithoutUpdate (instance, value) {
    getRMI(instance).setDataWithoutUpdate(getCompId(instance), value);
}

function getData (instance, valueName) {
    return getRMI(instance).getData(getCompId(instance))[valueName];
}

function getFullDataWithOverrides (instance, valueName) {
    return getRMI(instance).getFullDataWithOverrides(getCompId(instance))[valueName];
}

function onEvent (instance, eventName, cb) {
    getRMI(instance).registerEvent(getContextId(instance), getCompId(instance), eventName, getControllerId(instance), cb);
    return instance;
}

function getEvents(instance) {
    return getRMI(instance).getEvents(getCompId(instance));
}

export {
    getRMI,
    setProp,
    getProp,
    setData,
    setDataWithoutUpdate,
    getData,
    getFullDataWithOverrides,
    onEvent,
    getEvents
};
